
import { v4 as uuidv4 } from 'uuid';
import { connect } from 'react-redux';
import { store } from '../../Redux/store';
import kudzuPlusLogo from '../../assets/images/kudzuPluseLocgo.png'
import Logo from '../../assets/images/home_logo.png';
import VectorIcon from '../../assets/kudzu-plus-images/VectorIconGreen.png'
import VictorIconSavings from '../../assets/kudzu-plus-images/VectorIconBlue.png'
import customTool from '../../assets/kudzu-plus-images/Icon-Help.svg';
import HelpNormal from "../../assets/images/Icon-Help.svg";
import FilterIcon from '../../assets/images/Filter.png';
import FilterIconPlus from '../../assets/kudzu-plus-images/Filter-plus.png';
import GreyFilterIconPlus from '../../assets/kudzu-plus-images/greayfilter-plus.png';
import GreyFilterIcon from '../../assets/images/Filter_grey.png';
import SearchIcon from '../../assets/images/Search.png'
import SearchIconPlus from '../../assets/kudzu-plus-images/searchicon-plus.png'
import GraySearchIcon from '../../assets/images/graySearchIcon.png';
import GraySearchIconPlus from '../../assets/kudzu-plus-images/grey-search-plus.png';
import closeFilter from '../../assets/images/filter_colse.png';
import closeFilterPlus from '../../assets/kudzu-plus-images/filterClose.png';
import ClearIcon from '../../assets/images/ClearIcon.png'
import ClearIconPlus from '../../assets/kudzu-plus-images/Clear-plus.png';
import GoBtnIcon from '../../assets/images/GoBtn.png'
import GoBtnIconPlus from '../../assets/kudzu-plus-images/GoBtnPlus.png'
import CloseIcon from '../../assets/images/close.png';
import CloseIconPlus from '../../assets/kudzu-plus-images/search-close-plus.png';
import SidebarLogo from '../../assets/images/munuLogo4x.png';
import SidebarLogoPlus from '../../assets/kudzu-plus-images/kudzu-plus-white.png';
import dot from '../../assets/images/Radial Fill.png';
import dotPlus from '../../assets/kudzu-plus-images/Dot -plus.png';
import PersonalInfo from '../../assets/images/user.png';
import PersonalInfoPlus from '../../assets/kudzu-plus-images/personalIfologo.png';
import manageMoneyIcon from '../../assets/images/manageMoneyMenu.png';
import manageMoneyIconPlus from '../../assets/kudzu-plus-images/manageMoneyMenu_plus.png';
import CardServices from '../../assets/images/card_services.png';
import CardServicesPlus from '../../assets/kudzu-plus-images/cardservicesIcon.png';
import Accounts from '../../assets/images/accounts.png';
import AccountsPlus from '../../assets/kudzu-plus-images/accountServicesIcon.png';
import Security from '../../assets/images/security.png';
import SecurityPlus from '../../assets/kudzu-plus-images/securityIcon.png';
import Documents from '../../assets/images/documents.png';
import DocumentsPlus from '../../assets/kudzu-plus-images/documentsIcon.png';
import Settings from '../../assets/images/Settings.png';
import SettingsPlus from '../../assets/kudzu-plus-images/settingsIcon.png';
import Helpcircle from '../../assets/images/help-circle.png';
import HelpcirclePlus from '../../assets/kudzu-plus-images/helpIcon.png';
import Logout from '../../assets/images/log-out.png';
import LogoutPlus from '../../assets/kudzu-plus-images/logout-plus.png';
import blue_drop_down from '../../assets/images/blue_dropdown_arrow.png'
import blue_drop_downPlus from '../../assets/kudzu-plus-images/dropdownArrow.png'
import ArrowWhiteTwofac from '../../assets/images/arrow.png';
import ArrowWhiteTwofacPlus from '../../assets/kudzu-plus-images/arrow-twofac.png';
import ArrowTwofac_kudzplus from '../../assets/kudzu-plus-images/signUpnextArrow.png';
import createAccountNextArrowPlus from '../../assets/kudzu-plus-images/createAccountNext.png';  
import ArrowDisabledTwofacPlus from '../../assets/kudzu-plus-images/Caret.png';
import MblCopytext from '../../assets/images/mblCopytext.png'
import MblCopytextPlus from '../../assets/kudzu-plus-images/mobile-copy-plus.png';
import Copy_Text_Plus from '../../assets/kudzu-plus-images/mobile-copy-plus.png'
import toggleImageWithoutDot from '../../assets/images/toggle_imagee.png';
import toggleImageWithoutDotPlus from '../../assets/kudzu-plus-images/menu-icon-plus.png';
import HelpIcon from '../../assets/images/illo-help (1).png'
import HelpIconPlus from '../../assets/kudzu-plus-images/illo-help-plus.png'
import FindATM from '../../assets/images/illo-ATM.png'
import FindATMPlus from '../../assets/kudzu-plus-images/illo-ATM-dark-plus.png';
import RightArrow from '../../assets/images/Caret S.png'
import RightErrArrow from '../../assets/images/right_dropdown_arrow.png';
import RightErrArrowPlus from '../../assets/kudzu-plus-images/arrow-mangeAcc.png';
import RightArrowPlus from '../../assets/kudzu-plus-images/right-arrow-Plus.png';
import downArrow from "../../assets/images/downArrow.png"
import downArrowPlus from "../../assets/kudzu-plus-images/down-arrow-plus.png"
import upArrow from "../../assets/images/upArrow1.png"
import upArrowPlus from "../../assets/kudzu-plus-images/up-arrow-plus.png"
import Chat from '../../assets/images/chat.png'
import ChatPlus from '../../assets/kudzu-plus-images/chat-plus.png'
import Oops from '../../assets/images/Oops.png';
import Oopsplus from '../../assets/kudzu-plus-images/Oops.png';
import address_update_Succss from '../../assets/images/address-updated.png';
import address_update_SuccssKudzuplus from '../../assets/kudzu-plus-images/address_update_Succss.png';
import email_update_success from '../../assets/images/email_update_success.png';
import email_update_success_kudzuPlus from '../../assets/kudzu-plus-images/email_update_success.png';
import updatedphone_success from '../../assets/images/updatedphone_success.png';
import updatedphone_success_kudzuplus from '../../assets/kudzu-plus-images/updatedphone_success.png';
import LogokBlue from "../../assets/images/LogoKLIghtBlue.png";
import LogokBluePlus from "../../assets/kudzu-plus-images/LogoKLIghtBlue-plus.png";
import SecurityIcon from '../../assets/images/security.png'; 
import SecurityIcon_kudzuplus from '../../assets/kudzu-plus-images/security.png';
import Deviceremoved from '../../assets/images/illo-trusted-device-remove.png'; 
import Deviceremoved_kudzuplus from '../../assets/kudzu-plus-images/illo-trusted-device-remove.png';
import Bell from '../../assets/images/Bell.png';
import Bell_kudzuplus from '../../assets/kudzu-plus-images/Bell.png';
import SecurityLock from '../../assets/images/illo-security.png'; 
import SecurityLock_kudzuplus from '../../assets/kudzu-plus-images/illo-security.png';
import Showpassword from '../../assets/images/showpassword.png';
import Showpassword_kudzuplus from '../../assets/kudzu-plus-images/show_paswordPlus.png';
import Error from '../../assets/images/Error.png';
import Error_kudzuplus from '../../assets/kudzu-plus-images/Error.png';
import Check_icon from '../../assets/images/Check_icon.svg';
import Check_kudzuplus1 from '../../assets/kudzu-plus-images/Check_kudzuplus.svg';
import Pending_icon from '../../assets/images/Pending_icon.svg';
import Pending_kudzuplus from '../../assets/kudzu-plus-images/Pending_kudzuplus.svg';
import Exclamation_icon from '../../assets/images/Error_icon.svg';
import Exclamation_kudzuplus from '../../assets/kudzu-plus-images/Error_kudzuplus.svg';


import PasswordReset from '../../assets/images/activate_change_lock.png';
import PasswordReset_kudzuplus from '../../assets/kudzu-plus-images/activate_change_lock.png';
import Setting from '../../assets/images/Settings_green.png'
import Setting_kudzuplus from '../../assets/kudzu-plus-images/Settings.png'
import SettingIcon_kudzuplus from '../../assets/kudzu-plus-images/screw.png'
import SettingIcon from '../../assets/images/Settings.png';
// import notify from '../../assets/kudzu-plus-images/Bell.png';
// import BellNotify from '../../assets/images/BellNotify.png';
import CheckboxBlue from "../../assets/images/Checkbox-blue.png";
import CheckBoxBlueKudzu from '../../assets/kudzu-plus-images/CheckBox-kudzuplus.png';
import CheckBoxLightKudzu from '../../assets/kudzu-plus-images/Checkbox-kudzuplus-light.png';
import CheckboxLight from '../../assets/images/Checkbox-light.png';
import ArrowNatural from '../../assets/images/arrow.png';
import CaretRight from '../../assets/images/CaretBasic.png';
import CaretRightBlack from '../../assets/images/CaretBlack.png';
import CaretRightPlus from '../../assets/kudzu-plus-images/CaretPlus.png';
import ArrowPlusKudzu from '../../assets/kudzu-plus-images/CaretPlus.png';
import ArrowPlusKudzuModify from '../../assets/images/CaretShow.png';
import threeDotsNormal from "../../assets/images/Ellipses Large3_dots.png";
import threeDotsPlus from '../../assets/kudzu-plus-images/threeDotsPlus.png'
import unreadNormal from '../../assets/images/unread.png';
import unreadPlus from '../../assets/kudzu-plus-images/unreadPlus.png';
import isLogoKGreyPlus from '../../assets/kudzu-plus-images/LogokGreyPlus.png';
import isLogoKGreyActual from '../../assets/images/LogokGrey.png';
import RightArrowServives from '../../assets/images/right_dropdown_arrow.png';
import RightArrowServivesPlus from '../../assets/kudzu-plus-images/right-arrow-Plus.png';
import downloadArrowIconAddfunds from '../../assets/images/download_arrow.png';
import downloadArrowIconAddfundsPlus from '../../assets/kudzu-plus-images/illo-direct-deposit-dark.png';
import klogoWhite from '../../assets/images/LogokLogoLite.png';
import klogo_kudzuplus from '../../assets/kudzu-plus-images/LogokLogoLite.png';
import fpo from '../../assets/images/externalAccountsImg.png'; 
import fpo_kudzuplus from '../../assets/kudzu-plus-images/externalAccountsImg.png';
import AccountServiceIcon from '../../assets/images/accounts.png'; 
import AccountServiceIcon_kudzuplus from '../../assets/kudzu-plus-images/accounts.png';
import calendarImg_kudzuplus from '../../assets/kudzu-plus-images/calender_3x.png';
import calendarImg from '../../assets/images/calender_3x.png';
import transferRightArrow from '../../assets/images/RightArrow@2x.png';
import disableCheck from '../../assets/images/disableCheck.png';
import disableCheck_kudzuplus from '../../assets/kudzu-plus-images/disableCheck.png';
import NotAccept from "../../assets/images/Checkbox-light.png"
import NotAccept_kudzuplus from "../../assets/kudzu-plus-images/Checkbox-light.png";
import TransferError from "../../assets/images/transfer-error.png";
import TransferError_kudzuplus from "../../assets/kudzu-plus-images/transfer-error.png";
import datePickerRight from '../../assets/images/datePickerRight.png';
import datePickerRight_kudzuplus from '../../assets/kudzu-plus-images/datePickerRight.png';
import datePickerLeft from '../../assets/images/datePickerLeft.png';
import datePickerLeft_kudzuplus from '../../assets/kudzu-plus-images/datePickerLeft.png';
import ClimbImg from "../../assets/images/illo-climb-home.png";
import ClimbImg_kudzuplus from "../../assets/kudzu-plus-images/illo-climb-home.png";
import umbrella_kudzu from '../../assets/images/umbrella_kudzu.png';
import umbrella_kudzuplus from '../../assets/kudzu-plus-images/umbrella_kudzu.png';
import TransferImg from '../../assets/images/transfer.png';
import TransferImgForPlus from '../../assets/kudzu-plus-images/illo-transaction-dark.png';
import TransactionComplete from "../../assets/images/transfercomplete.png"
import DepositComplete from "../../assets/images/deposit-complete.png"

import TransactionCompletePlus from "../../assets/kudzu-plus-images/transfercomplete.png" 
import white_kudzu_logo from '../../assets/images/white_kudzu_logo.png';
import kudzu_logo_kudzuplus from '../../assets/kudzu-plus-images/greenLogo.png';
import kudzu_green_card from '../../assets/images/kudzu_green_card.png'
import kudzu_green_card_kudzuplus from '../../assets/kudzu-plus-images/kudzu_green_card.png'
import lock_card_on from '../../assets/images/lock_card_on.png' 
import lock_card_on_kudzuplus from '../../assets/kudzu-plus-images/lock_card_on.png'
import lock_card_off from '../../assets/images/card_service_lock.png' 
import lock_card_off_kudzuplus from '../../assets/kudzu-plus-images/card_service_lock.png'
import kudzu_blue_card from '../../assets/images/kudzu_blue_card.png'
import kudzu_blue_card_kudzuplus from '../../assets/kudzu-plus-images/kudzu_blue_card.png'
import Addalerts from '../../assets/images/add_alerts.png';
import Addalerts_kudzuplus from '../../assets/kudzu-plus-images/add_alerts.png';
import CoveredByKudzuImg from '../../assets/images/illo-covered-by-kudzu.png';
import CoveredByKudzuImg_plus from '../../assets/kudzu-plus-images/illo-covered-by-kudzu-darkPluss.png';
import CoveredByKudzuImg_kudzuplus from '../../assets/kudzu-plus-images/illo-covered-by-kudzu-dark-new.png';
import SavingsHabitImg from '../../assets/images/illo-savings-habits.png';
import SavingsHabitImg_kudzuplus from '../../assets/kudzu-plus-images/illo-savings-habits.png';
import RightArrowClimb from "../../assets/images/arrow.png";
import RightArrowClimbPlus from '../../assets/kudzu-plus-images/RightArrowPlus.png';   
 
import statement_page from '../../assets/images/statement_page.png';
import statement_page_plus from '../../assets/kudzu-plus-images/statement_plus.png';
import blue_right_arrow from '../../assets/images/RightArrow@2x.png';
import blue_right_arrow_plus from '../../assets/kudzu-plus-images/blue_right_arrow_plus.png';
import shredding_statement from '../../assets/images/shredding_statement.png';
import shredding_statement_plus from '../../assets/kudzu-plus-images/shredding_statement_plus.png'; 
import ClimbIcon from '../../assets/images/illo-climb.png';
import ClimbIcon_kudzuplus from '../../assets/kudzu-plus-images/Climb-logo.png';
import dotCbkPlus from '../../assets/kudzu-plus-images/notificationCbkDot.png';
import smi_one from '../../assets/smi-kudzu-images/smi_card_services.png';
import KudzuNewIcon from '../../assets/kudzu-plus-images/kudzu_plus_new.png';
import ToolkitImg_kudzuplus from '../../assets/kudzu-plus-images/kudzu_plus_toolkit.png';
import CardServicesPLusImg from '../../assets/kudzu-plus-images/card-services-footer-plus.png';
import CardServicesBasicImg from '../../assets/kudzu-plus-images/card_services_footer_basic.png'





















//payperks 
import PayPerksImg from '../../assets/images/payperks_days.png';
import PayPerksImgPlus from '../../assets/kudzu-plus-images/payperks_days.png';
import Homepayperks from '../../assets/images/homepayperks.png';
import HomepayperksPlus from '../../assets/kudzu-plus-images/homepayperks.png';
import Check from '../../assets/images/acceptedcheck.png'
import Check_kudzuplus from '../../assets/kudzu-plus-images/acceptedcheck.png'
import ToolTipArrow from '../../assets/images/Tooltip_Arrow.png'
import ToolTipArrowPlus from '../../assets/kudzu-plus-images/Tooltip_Arrow.png'
import ineligibleIcon from '../../assets/images/covered_by_kudzu_ineligible.png'
import ineligibleIcon_kudzuplus from '../../assets/kudzu-plus-images/illo-report-dark.png'
import SpendAlertsPause from "../../assets/images/illo-pause.png";
import SpendAlertsPause_kudzuplus from "../../assets/kudzu-plus-images/illo-pause-dark.png";
import SpendAlertsPauseSuccess from '../../assets/images/illo-pause-done.png';
import SpendAlertsPauseSuccess_kudzuplus from '../../assets/kudzu-plus-images/illo-pause-done-dark.png';
import covered_by_kudzu_success from '../../assets/images/covered_by_kudzu_success.png';
import covered_by_kudzu_success_kudzuplus from '../../assets/kudzu-plus-images/illo-covered-by-kudzu-done-dark.png';
import overageMonth from '../../assets/images/overageMonth.png';
import overageMonth_kudzuplus from '../../assets/kudzu-plus-images/overageMonth.png';
import ModalLogo from '../../assets/images/modal_logo.png';
import ModalLogo_kudzplus from '../../assets/kudzu-plus-images/modal_logo.png';
import EmailIcon from "../../assets/images/email.png";
import EmailIcon_kudzuplus from "../../assets/kudzu-plus-images/email.png";
import transactionErrorIcon from "../../assets/images/transfer-error.png"
import transactionErrorIconPlus from "../../assets/kudzu-plus-images/transfer-error.png"
import RadialFill from '../../assets/images/Radial Fill.png';
import RadialNullPlus from '../../assets/kudzu-plus-images/Radial_Null_Plus.png';
import RadialNull from '../../assets/images/Radial Null.png';
import RightArrowVan from "../../assets/images/RightArrow@2x.png";
import RightArrowVanPlus from '../../assets/kudzu-plus-images/NextArrowActive.png';
  
 
import Arrow from '../../assets/images/arrow.png';
import ArrowClimbPlus from '../../assets/kudzu-plus-images/CaretClimb.png';
import RightArrowNormals from "../../assets/images/RightArrow@2x.png";
import RightArrowPlusz from '../../assets/kudzu-plus-images/CaretAddSaving.png'
import NextArrow from "../../assets/images/Next_Arrow.png";
import NextArrowInactive from '../../assets/kudzu-plus-images/NextArrowInactive.png';

import spendingAlertSuccess from "../../assets/images/spending-alert-success.png";

import spendingAlertSuccessPlus from '../../assets/kudzu-plus-images/spending-success.png';

import ClimbIconForPlus from '../../assets/kudzu-plus-images/SmartRoots.png';
import ClimbIconForPlusOne from '../../assets/kudzu-plus-images/Climb-logo.png';

import spendingAlertError from "../../assets/images/spending-alert-error.png";
import spendingAlertErrorPluss from "../../assets/kudzu-plus-images/reports-dark.png";

import RadialNullNormal from '../../assets/images/Checkbox-light.png';
import RadialNullPlusNot from '../../assets/kudzu-plus-images/CheckboxNullPlus.png';

import diagNormal from '../../assets/images/covered_by_kudzu_success.png';
import diagPlus from '../../assets/kudzu-plus-images/illo-covered-by-kudzu-plus-done-dark.png';

import savingsHabitSuccess from "../../assets/images/savings-habit-done.png";
import savingHabitSuccessPlus from '../../assets/kudzu-plus-images/illo-savings-habit-done-dark.png';

import savingsHabitremoveSuccess from "../../assets/images/illo-savings-habit-remove.png"; 
import savingHabitremoveSuccessPlus from '../../assets/kudzu-plus-images/hab-remove.png';

import checkbox_null from "../../assets/images/Checkbox-light.png";
import checkbox_null_plus from '../../assets/kudzu-plus-images/Check-box-plus.png';

import confirmRemoveImg from '../../assets/images/illo-spending-alert-remove.png';
import confirmRemoveImgPlus from '../../assets/kudzu-plus-images/illo-spending-alert-remove-dark.png';

import SucessRemoveImg from '../../assets/images/illo-spending-alert-done.png';
import SuccessRemoveImgPlus from '../../assets/kudzu-plus-images/illo-spending-alert-done-dark.png';

import spendingAlertErrorMan from "../../assets/images/spending-alert-error.png";
import spendingAlertErrorManPlus from "../../assets/kudzu-plus-images/illo-report-dark.png";

import checkbox_nullmarvel from "../../assets/images/Checkbox-light.png";
import checkbox_nullmarvelPlus from '../../assets/kudzu-plus-images/reactnull.png';

import SpendAlertsPauseMan from "../../assets/images/illo-pause.png";
import SpendAlertPauseManPlus from '../../assets/kudzu-plus-images/illo-pause-darkManPlus.png';

import coverkudzu from '../../assets/images/illo-covered-by-kudzu.png';
import coverkudzuplus from '../../assets/kudzu-plus-images/illo-covered-by-kudzu-darkPluss.png';
import coveredkudzuplusumbrella from '../../assets/kudzu-plus-images/illo-covered-by-kudzuplus-umbrellas.png';

import checkbox_nullNorm from "../../assets/images/Checkbox-light.png";
import checkbox_nullPlus from "../../assets/kudzu-plus-images/checksumnullplus.png";

import buttonNormal from "../../assets/images/illo-covered-by-kudzu.png";
import buttonPlus from "../../assets/kudzu-plus-images/illo-covered-by-kudzu-darkbuttonPlus.png";

import btnprimaryNorm from '../../assets/images/covered_by_kudzu_success.png';
import btnprimaryPlus from '../../assets/kudzu-plus-images/illo-covered-by-kudzu-done-darkHulk.png';

import  Sucessfromtelusko from '../../assets/images/covered_by_kudzu_success.png';
import Sucesssfromteluskoplus from '../../assets/kudzu-plus-images/illo-covered-by-kudzu-done-darkTelusko.png';

import call from '../../assets/images/calender_3x.png';
import callPlus from '../../assets/kudzu-plus-images/Vectorcall.png';

import cellbio from "../../assets/images/beneficiarysaving.png";
import cellbioPlus from "../../assets/kudzu-plus-images/Benificiary.png";

import Arrowdq from '../../assets/images/arrow.png';
import ArrowdqPlus from "../../assets/kudzu-plus-images/CaretWhite.png";

import Arrowcheck from '../../assets/images/arrow.png';

import ShowSSNPic from '../../assets/images/showpassword.png';
import ShowSSNPicPlus from '../../assets/kudzu-plus-images/RevealPlus.png';

import ArrowCont from '../../assets/images/arrow.png';
import ArrowContPlus from '../../assets/kudzu-plus-images/CaretsPlussd.png';

import SuccessPlusToDo from "../../assets/kudzu-plus-images/Frames.png";
import SuccessToDo from "../../assets/images/savings_optin_success.png"; 
import kudzu_$50 from "../../assets/images/kudzu_50$.png";
import kudzu_$50_kudzuplus from "../../assets/kudzu-plus-images/coveredBy3plus.png";

import kudzu_spend_plus from "../../assets/kudzu-plus-images/illo-spendsense-dark.png"
import kudzu_spend_normal from "../../assets/images/illo-spendsense.png"


import kudzu_saving_email_plus from "../../assets/kudzu-plus-images/illo-email-updated-dark.png"
import kudzu_saving_email_normal from "../../assets/images/email_update_success.png"
import SpendIcon2 from '../../assets/images/spend_alert_2-1.png';
import SpendIcon2Plus from '../../assets/kudzu-plus-images/spendsenseAlert2plus.png';
import savingsHabits2 from '../../assets/images/savings_habit_2_icon.png';
import savingsHabits2Plus from '../../assets/kudzu-plus-images/kudzu_50$.png';
import Cookies from 'js-cookie';

import Trusted from "../../assets/images/illo-trusted-devices.png";
import Trustedplus from '../../assets/kudzu-plus-images/illo-trusted-devices-dark.png';

import Lock from "../../assets/images/activate_change_lock.png";
import LockPlus from "../../assets/kudzu-plus-images/illo-set-dark.png";

import ArrowYesPlus from '../../assets/kudzu-plus-images/CaretWhite.png';
import ArrowYesNormal from "../../assets/images/CaretYesNorm.png";

import ArrowNoPlus from "../../assets/kudzu-plus-images/CaretNoPlus.png";
import ArrowNoNormal from "../../assets/images/CaretNoNormal.png";
import savingsGoalclimsettingsPlus from "../../assets/kudzu-plus-images/illo-beneficiary-dark-savingsgoal.png";
import savingsGoalclimsettings from "../../assets/images/beneficiaryrmveSucess.png";
import report_a_problem_flag from '../../assets/images/report_a_problem_flag.png';
import report_a_problem_flag_plus from '../../assets/kudzu-plus-images/Fraud-Plus.png';
import secured_card_front from '../../assets/images/secured_card_front.png';

import Toggle from '../../assets/images/Toggle.svg';
import Toggle_Selected from '../../assets/images/Toggle_Selected.svg';

import Toggle_Kudzuplus from "../../assets/kudzu-plus-images/Toggle_Kudzuplus.svg";
import Toggle_Selected_Kudzuplus from "../../assets/kudzu-plus-images/Toggle_Selected_Kudzuplus.svg";

import Toggle_Mobile from '../../assets/images/Toggle_Mobile.svg';
import Toggle_Mobile_Selected from '../../assets/images/Toggle_Mobile_Selected.svg';

import Toggle_Mobile_Kudzuplus from "../../assets/kudzu-plus-images/Toggle_Mobile_Kudzuplus.svg";
import Toggle_MobileSelected_Kudzuplus from "../../assets/kudzu-plus-images/Toggle_Mobile_Selected_Kudzuplus.svg";


//smione





import { t } from 'i18next';

export async function getDeviceId() {
    let deviceId = uuidv4();
    return deviceId;
}

// export const fetchConfigarationData = async () => {
//     const response = await fetch(`${process.env.PUBLIC_URL}/app-config.json`);
//     const data = await response.json();
//     return data;

//   };


export function kudzuPlusTrueFun(responseObj){
    if (responseObj != undefined ) {
        if (responseObj.length > 0) {
            return responseObj[0].IsKudzuPlusProduct
        }
    }else{
        return false;
    }
}

export const capitalizeFirstLetter = (text) => {
    if (!text) return text;
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };
  
export function appTheme(isPlusAccount) {
    return {
        kudzu_climb_color:isPlusAccount? "#94C3E8" : "#ffffff",
        kudzu_spend:isPlusAccount? kudzu_spend_plus: kudzu_spend_normal,
        
        kudzu_saving_email:isPlusAccount ? kudzu_saving_email_plus :kudzu_saving_email_normal,
          kudzuLogo:isPlusAccount ? KudzuNewIcon : Logo,
        //   spendingAndSavingsNavBg:isPlusAccount ? "--dynamic-header-bg" : "--navbar-bg",
          isWhiteBgForCard:isPlusAccount ? false  : true,
          isDarkBgForCard:isPlusAccount ? true  : false,
          isDarkBgForCardService:isPlusAccount ? false  : true,  
          isGreenIconForSpending:isPlusAccount ? VectorIcon : "",
          isBlueIconForSavings:isPlusAccount ? VictorIconSavings : "",
          filterIcon:isPlusAccount ? FilterIconPlus : FilterIcon,
          greyfilterIcon:isPlusAccount ? GreyFilterIconPlus : GreyFilterIcon,
          searchIcon:isPlusAccount ? SearchIconPlus : SearchIcon,
          greysearchIcon:isPlusAccount ? GraySearchIconPlus : GraySearchIcon,
          filterBtnBgDisable:isPlusAccount ? 'var(--transactions-filter-range-bg-disable)' : '',
          filterClose:isPlusAccount ? closeFilterPlus : closeFilter,
          smiOneFilterClose:isPlusAccount ? closeFilterPlus : closeFilterPlus,
          clearIcon:isPlusAccount ? ClearIconPlus : ClearIcon,
          goBtnIcon:isPlusAccount ? GoBtnIconPlus : GoBtnIcon,
          searchCloseIcon:isPlusAccount ? CloseIconPlus : CloseIcon,
          sideBarLogo:isPlusAccount ? SidebarLogoPlus : SidebarLogo,
          sideBarDot:isPlusAccount ? dotPlus : dot,
          sideBarDotForCbk:isPlusAccount ? dotCbkPlus : dot,
          personalIfoIcon:isPlusAccount ? PersonalInfoPlus : PersonalInfo,
          manageMoneyIcon: isPlusAccount ? manageMoneyIconPlus : manageMoneyIcon,
          cardservicesIcon:isPlusAccount ? CardServicesPlus : CardServices,
          accountsIcon:isPlusAccount ? AccountsPlus : Accounts,
          securityIcon:isPlusAccount ? SecurityPlus : Security,
          documentsIcon:isPlusAccount ? DocumentsPlus : Documents,
          settingsIcon:isPlusAccount ? SettingsPlus : Settings,
          helpcircleIcon:isPlusAccount ? HelpcirclePlus : Helpcircle,
          logoutIcon:isPlusAccount ? LogoutPlus : Logout ,
          dropDownIcon:isPlusAccount ? blue_drop_downPlus : blue_drop_down ,
          arrowWhiteTwofac:isPlusAccount ? ArrowWhiteTwofacPlus : ArrowWhiteTwofac ,
          arrowDisabledTwofac:isPlusAccount ? ArrowDisabledTwofacPlus : ArrowWhiteTwofac ,
          mblCopytextIcon:isPlusAccount ? MblCopytextPlus : MblCopytext ,
          payperks:isPlusAccount ? PayPerksImgPlus : PayPerksImg ,
          Homepayperks:isPlusAccount ? HomepayperksPlus : Homepayperks ,
          toggleImageWithoutDot:isPlusAccount ? toggleImageWithoutDotPlus : toggleImageWithoutDot ,
          helpIcon:isPlusAccount ? HelpIconPlus : HelpIcon ,
          findATMIcon:isPlusAccount ? FindATMPlus : FindATM ,
          rightArrow:isPlusAccount ? RightArrowPlus : RightArrow ,
          rightArrowServices:isPlusAccount ? RightArrowServivesPlus : RightArrowServives ,
          upArrowIcon:isPlusAccount ? upArrowPlus : upArrow ,
          downArrowIcon:isPlusAccount ? downArrowPlus : downArrow ,
          chatIcon:isPlusAccount ? ChatPlus : Chat ,
          OopsIcon:isPlusAccount ? Oopsplus : Oops ,
          addressUpdateSuccss:isPlusAccount ? address_update_SuccssKudzuplus : address_update_Succss ,
          emailUpdateSuccss:isPlusAccount ? email_update_success_kudzuPlus : email_update_success ,
          phoneUpdateSuccss:isPlusAccount ? updatedphone_success_kudzuplus : updatedphone_success ,
          logokBlueIcon:isPlusAccount ? LogokBluePlus : LogokBlue ,
          securityIcon:isPlusAccount ? SecurityIcon_kudzuplus : SecurityIcon ,
          deviceRemoveIcon:isPlusAccount ? Deviceremoved_kudzuplus : Deviceremoved ,
          Bell:isPlusAccount ? Bell_kudzuplus : Bell ,
          SecurityLock:isPlusAccount ? SecurityLock_kudzuplus : SecurityLock ,
          Showpassword:isPlusAccount ? Showpassword_kudzuplus : Showpassword ,
          Error:isPlusAccount ? Error_kudzuplus : Error ,
          Check:isPlusAccount ? Check_kudzuplus1 : Check_icon ,
          Pending:isPlusAccount ? Pending_kudzuplus : Pending_icon ,
          ExclamationError:isPlusAccount ? Exclamation_kudzuplus : Exclamation_icon ,
          Toggle:isPlusAccount ? Toggle_Kudzuplus : Toggle ,
          Toggle_Selected:isPlusAccount ? Toggle_Selected_Kudzuplus : Toggle_Selected ,
          Toggle_Mobile:isPlusAccount ? Toggle_Mobile_Kudzuplus : Toggle_Mobile ,
          Toggle_Mobile_Selected:isPlusAccount ? Toggle_MobileSelected_Kudzuplus : Toggle_Mobile_Selected ,
          PasswordReset:isPlusAccount ? PasswordReset_kudzuplus : PasswordReset ,
          welcomeKudzuText:isPlusAccount ? t('welcm_to_kudzu+') : t("welcm_to_kudzu") ,
          SettingIcon:isPlusAccount ? Setting_kudzuplus : Setting ,
          SettingBreadcrumbIcon:isPlusAccount ? SettingIcon_kudzuplus : SettingIcon,
        //   BellIcon:isPlusAccount?notify:BellNotify,
           BellIconShow: isPlusAccount ? Bell_kudzuplus : Bell,
           ArrowsIconToSee:isPlusAccount?RightErrArrowPlus :RightErrArrow,
           customToolsToSee:isPlusAccount?customTool :HelpNormal,
        //    Checkbox-kudzu:isPlusAccount? 
        customCheckBoxToSee:isPlusAccount?CheckBoxBlueKudzu: CheckboxBlue,
        customCheckBoxLightToSee: isPlusAccount ? CheckBoxLightKudzu : CheckboxLight,
        ArrowKudzuTo: isPlusAccount ? ArrowPlusKudzu : ArrowPlusKudzuModify,
        CaretRight: isPlusAccount ? CaretRightPlus : CaretRight,
        CaretRightBlack: isPlusAccount ? CaretRightPlus : CaretRightBlack,
        isheaderBgNotify:isPlusAccount?true:false,
        isbodyBgNotify:isPlusAccount?true:false,
        threeDots:isPlusAccount?threeDotsPlus:threeDotsNormal,
        unread:isPlusAccount?unreadPlus:unreadNormal,
        isLogoKGreyActual:isPlusAccount?isLogoKGreyPlus:isLogoKGreyActual,
    
          borderTopForAccServices:isPlusAccount ? false : true ,
          downArrowIconAddfunds:isPlusAccount ? downloadArrowIconAddfundsPlus : downloadArrowIconAddfunds ,
          Klogo:isPlusAccount ? klogo_kudzuplus : klogoWhite ,
          FPO:isPlusAccount ? fpo_kudzuplus : fpo ,
          AccountServiceIcon:isPlusAccount ? AccountServiceIcon_kudzuplus : AccountServiceIcon ,
          calendarImg:isPlusAccount ? calendarImg_kudzuplus : calendarImg ,
          transferRightArrow:isPlusAccount ? ArrowWhiteTwofacPlus : transferRightArrow ,
          disableCheck:isPlusAccount ? disableCheck_kudzuplus : disableCheck ,
          NotAccept:isPlusAccount ? NotAccept_kudzuplus : NotAccept ,
          TransferErrorIcon:isPlusAccount ? TransferError_kudzuplus : TransferError ,
          datePickerRight:isPlusAccount ? datePickerRight_kudzuplus : datePickerRight ,
          datePickerLeft:isPlusAccount ? datePickerLeft_kudzuplus : datePickerLeft ,
          ClimbImg:isPlusAccount ? ToolkitImg_kudzuplus : ClimbImg ,
          CardServicesFooter: isPlusAccount ? CardServicesPLusImg : CardServicesBasicImg ,
          Umbrella_kudzu:isPlusAccount ? umbrella_kudzuplus : umbrella_kudzu ,
          TransferImg:isPlusAccount ? TransferImgForPlus : TransferImg ,
          TransactionComplete:isPlusAccount ? TransactionCompletePlus : TransactionComplete ,
          DepositComplete:isPlusAccount ? DepositComplete : DepositComplete , 
          kudzulogoCard:isPlusAccount ? kudzu_logo_kudzuplus : white_kudzu_logo ,
          kudzu_green_card:isPlusAccount ? kudzu_green_card_kudzuplus : kudzu_green_card ,
          smiOne_card:isSmiOneAccountTrue ? smi_one : kudzu_green_card,
          lock_card_on:isPlusAccount ? lock_card_on_kudzuplus : lock_card_on ,
          lock_card_off:isPlusAccount ? lock_card_off_kudzuplus : lock_card_off ,
          kudzu_blue_card:isPlusAccount ? kudzu_blue_card_kudzuplus : kudzu_blue_card ,
          Acceptedcheck:isPlusAccount ? Check_kudzuplus : Check ,
          tooltipArrowForNotification:isPlusAccount ? ToolTipArrowPlus : ToolTipArrow ,
          arrowDisabledTwofac:isPlusAccount ? ArrowDisabledTwofacPlus : ArrowWhiteTwofac ,
          climbAddalerts:isPlusAccount ? Addalerts_kudzuplus : Addalerts ,
          climbCoveredByKudzu:isPlusAccount ? CoveredByKudzuImg_kudzuplus : CoveredByKudzuImg ,
          climbCoveredByKudzuwithOutcheck:isPlusAccount ? CoveredByKudzuImg_plus : CoveredByKudzuImg ,
          climbSavingsHabitImg:isPlusAccount ? SavingsHabitImg_kudzuplus : SavingsHabitImg ,
          nextArrow : isPlusAccount? RightArrowClimbPlus:RightArrowClimb,
          coveredByKudzuIneligibleineligibleIcon : isPlusAccount? ineligibleIcon_kudzuplus : ineligibleIcon,
          SpendAlertsPause : isPlusAccount? SpendAlertsPause_kudzuplus : SpendAlertsPause,
          SpendAlertsPauseSuccess : isPlusAccount? SpendAlertsPauseSuccess_kudzuplus : SpendAlertsPauseSuccess,
          coveredBySuccess : isPlusAccount? covered_by_kudzu_success_kudzuplus : covered_by_kudzu_success,
          climbOverageMonth : isPlusAccount? overageMonth_kudzuplus : overageMonth,
          ModalLogo : isPlusAccount? ModalLogo_kudzplus : ModalLogo,
          EmailIcon : isPlusAccount? EmailIcon_kudzuplus : EmailIcon,
          SignupNextArrow : isPlusAccount? ArrowTwofac_kudzplus : ArrowWhiteTwofac,
          createAccountNextArrow:isPlusAccount ? createAccountNextArrowPlus : ArrowWhiteTwofac ,
          transferErrorMessage:isPlusAccount ? transactionErrorIconPlus : transactionErrorIcon ,

          nextArrow : isPlusAccount?RightArrowClimbPlus:RightArrowClimb,
          ClimbArrow: isPlusAccount ? ArrowClimbPlus : Arrow,
          CaretDiamond:isPlusAccount?RightArrowPlusz:RightArrowNormals,
          RadialNulls:isPlusAccount?RadialNullPlus:RadialNull,
          NextArrowInactive:isPlusAccount?NextArrowInactive:NextArrow,
          RightArrowActive:isPlusAccount?RightArrowVanPlus:RightArrowVan,
          kudzu_statementsIcon:isPlusAccount? statement_page_plus: statement_page,
          kudzu_arrow_to:isPlusAccount?blue_right_arrow_plus:blue_right_arrow,
          kudzu_Document_Footer_Icon:isPlusAccount?shredding_statement_plus:shredding_statement,
          spending_alert_success_icon:isPlusAccount?spendingAlertSuccessPlus:spendingAlertSuccess,
          ClimbIcon:isPlusAccount?ClimbIconForPlusOne:ClimbIconForPlus,
          reportErrords:isPlusAccount?spendingAlertErrorPluss:spendingAlertError,
          radialnull:isPlusAccount?RadialNullPlusNot:RadialNullNormal,
          diag:isPlusAccount?diagPlus:diagNormal,
          picSuccsess:isPlusAccount?savingHabitSuccessPlus:savingsHabitSuccess,
          picRemove:isPlusAccount?savingHabitremoveSuccessPlus:savingsHabitremoveSuccess,
          notifynullicon:isPlusAccount?checkbox_null_plus:checkbox_null,
          removenotify:isPlusAccount?confirmRemoveImgPlus:confirmRemoveImg,
          removenotifysuccess:isPlusAccount?SuccessRemoveImgPlus:SucessRemoveImg,
          showIcMan:isPlusAccount?spendingAlertErrorManPlus:spendingAlertErrorMan,
          shownullMarvel:isPlusAccount?checkbox_nullmarvelPlus:checkbox_nullmarvel,
          isman:isPlusAccount?SpendAlertPauseManPlus:SpendAlertsPauseMan,
          isUmbrella:isPlusAccount?coveredkudzuplusumbrella:coverkudzu,
          isBatCheck:isPlusAccount?checkbox_nullPlus:checkbox_nullNorm,
          isButton:isPlusAccount?buttonPlus:buttonNormal,
          isbtnprim:isPlusAccount?btnprimaryPlus:btnprimaryNorm,
          isSuccesstelusko:isPlusAccount?Sucesssfromteluskoplus: Sucessfromtelusko,
          callAcc:isPlusAccount?callPlus:call,
          cell:isPlusAccount?cellbioPlus:cellbio,
          isHabit:isPlusAccount?ArrowdqPlus:Arrowdq,
          showPass:isPlusAccount?ShowSSNPicPlus:ShowSSNPic,
          isArrowDynamic:isPlusAccount?ArrowContPlus:ArrowCont,
          issucesstodo:isPlusAccount?SuccessPlusToDo:SuccessToDo,
          kudzu_$50_kudzuplusIcon:isPlusAccount?kudzu_$50_kudzuplus:kudzu_$50,
          ClimbLogo:isPlusAccount?ClimbIcon_kudzuplus:ClimbIcon,
          SpendSenseIcon2:isPlusAccount?SpendIcon2Plus:SpendIcon2,
          savingsHabitsIcon2:isPlusAccount?savingsHabits2Plus:savingsHabits2,
          successIconTrust:isPlusAccount?Trustedplus:Trusted,
          LockIconTrust:isPlusAccount?LockPlus:Lock,
          ArrowYes:isPlusAccount?ArrowYesPlus:ArrowYesNormal,
          ArrowNo:isPlusAccount?ArrowNoPlus:ArrowNoNormal,
          climbSavingsGoalImg:isPlusAccount?savingsGoalclimsettingsPlus:savingsGoalclimsettings,
          report_a_problem_icon:isPlusAccount?report_a_problem_flag_plus:report_a_problem_flag,
          secured_card_front:isPlusAccount?secured_card_front:secured_card_front

    }}



export async function fetchConfigarationData(isFromApi) {
    const configdatafromRedux = store.getState().appConfigData;
    const isB2c = store.getState().preferredIdentity;
    const kudzuPlusSetForCookies = `kudzuPlusTrueFromCookies`;
    const kudzuPlusTrueFromCookies = Cookies.get(kudzuPlusSetForCookies) === 'true';

    if (configdatafromRedux !== null && isFromApi == undefined) {
        return configdatafromRedux;
    } 
    else if (isFromApi == true) {
       const response = await fetch(`${process.env.PUBLIC_URL}/app-config.json`);
       const data = await response.json();
       const updatedData =   {
            ...data,
            AUTH_URL: isB2c ? data.AUTH_URL_B2C : data.AUTH_URL,
            CLIENT_SECRET: isB2c ? data.CLIENT_SECRET_B2C : data.CLIENT_SECRET,
            TWO_FACT_SCOPE: isB2c ? data.TWO_FACT_SCOPE_B2C : data.TWO_FACT_SCOPE,
            DARK_MODE: kudzuPlusTrueFromCookies ? true : false
            // APP_URL: isB2c ? data.APP_URL_B2C : data.APP_URL,
            // GOOGLE_CLIENT_ID: isB2c ? data.GOOGLE_CLIENT_ID_B2C : data.GOOGLE_CLIENT_ID,
            // APPLE_TEAM_ID: isB2c ? data.APPLE_TEAM_ID_B2C : data.APPLE_TEAM_ID,
            // APPLE_REDIRECT_URI: isB2c ? data.APPLE_REDIRECT_URI_B2C : data.APPLE_REDIRECT_URI,
          };
        console.log(updatedData,"updatedData appConfigData")
        const appConfigPayload = { appConfigData: updatedData };
        store.dispatch({ type: 'STORE_APPCONFIGDATA', payload: appConfigPayload });
        return updatedData;
    }
    else {
       const response = await fetch(`${process.env.PUBLIC_URL}/app-config.json`);
       const data = await response.json();
       const updatedData =   {
            ...data,
            AUTH_URL: isB2c ? data.AUTH_URL_B2C : data.AUTH_URL,
            CLIENT_ID: isB2c ? data.CLIENT_ID_B2C : data.CLIENT_ID,
            CLIENT_SECRET: isB2c ? data.CLIENT_SECRET_B2C : data.CLIENT_SECRET,
            TWO_FACT_SCOPE: isB2c ? data.TWO_FACT_SCOPE_B2C : data.TWO_FACT_SCOPE,
            // APP_URL: isB2c ? data.APP_URL_B2C : data.APP_URL,
            // GOOGLE_CLIENT_ID: isB2c ? data.GOOGLE_CLIENT_ID_B2C : data.GOOGLE_CLIENT_ID,
            // APPLE_TEAM_ID: isB2c ? data.APPLE_TEAM_ID_B2C : data.APPLE_TEAM_ID,
            // APPLE_REDIRECT_URI: isB2c ? data.APPLE_REDIRECT_URI_B2C : data.APPLE_REDIRECT_URI,
          };
        console.log(updatedData,"updatedData appConfigData")
        const appConfigPayload = { appConfigData: updatedData };
        store.dispatch({ type: 'STORE_APPCONFIGDATA', payload: appConfigPayload });
        return updatedData;
    }
}

export const setCookieValueForNew = (value) => {
    if(value){
        const cardsValue = store.getState().userCards;
        const newUserBadge = `newUserBadge${cardsValue[0].CardKey}`;
        Cookies.set(newUserBadge, 'true', { expires: 1825 }); 
        return true
    }
    else return false
   
};

export const frequencyDataConverted = (frequency) => {

    let frequencyData = '';
    switch (frequency) {
        case 'OT':
            frequencyData = 'One Time';
            break;
        case 'DY':
            frequencyData = 'Daily';
            break;
        case 'WY':
            frequencyData = 'Weekly';
            break;
        case 'MY':
            frequencyData = 'Monthly';
            break;
       
        default:
            frequencyData = '';
    }
    return frequencyData;
}


export const decimalValidation = (editedValue) => {
    if (editedValue && editedValue.includes(".")) {
        let [integerPart, decimalPart] = editedValue.split(".");
        integerPart = integerPart.replace("$", ""); 
        if (!decimalPart) {
            return `${integerPart}.00`; 
        } else if (decimalPart.length === 1) {
            return `${integerPart}.0${decimalPart}`; 
        } else {
            return `${integerPart}.${decimalPart.substring(0, 2)}`; 
        }
    } else if (editedValue) {
        return editedValue.replace("$", "") + ".00"; 
    }

    return editedValue.toString().replace("$", ""); 
};
  

// export async function fetchConfigarationData(isFromApi) {
//     const configdatafromRedux = store.getState().appConfigData;
//     const isB2c = store.getState().preferredIdentity;
//     if (configdatafromRedux !== null && isFromApi == undefined) {
//         return configdatafromRedux;
//     } 
//     else if (isFromApi == true) {
//        const response = await fetch(`${process.env.PUBLIC_URL}/app-config.json`);
//        const data = await response.json();
//        const updatedData =   {
//             ...data,
//             AUTH_URL: isB2c ? data.AUTH_URL_B2C : data.AUTH_URL,
//             CLIENT_ID: isB2c ? data.CLIENT_ID_B2C : data.CLIENT_ID,
//             CLIENT_SECRET: isB2c ? data.CLIENT_SECRET_B2C : data.CLIENT_SECRET,
//             TWO_FACT_SCOPE: isB2c ? data.TWO_FACT_SCOPE_B2C : data.TWO_FACT_SCOPE,
//             // APP_URL: isB2c ? data.APP_URL_B2C : data.APP_URL,
//             GOOGLE_CLIENT_ID: isB2c ? data.GOOGLE_CLIENT_ID_B2C : data.GOOGLE_CLIENT_ID,
//             APPLE_TEAM_ID: isB2c ? data.APPLE_TEAM_ID_B2C : data.APPLE_TEAM_ID,
//             APPLE_REDIRECT_URI: isB2c ? data.APPLE_REDIRECT_URI_B2C : data.APPLE_REDIRECT_URI,
//           };
//           alert(JSON.stringify(updatedData))
//         console.log(updatedData,"updatedData appConfigData")
//         const appConfigPayload = { appConfigData: updatedData };
//         store.dispatch({ type: 'STORE_APPCONFIGDATA', payload: appConfigPayload });
//         return updatedData;
//     }
//     else {
//        const response = await fetch(`${process.env.PUBLIC_URL}/app-config.json`);
//        const data = await response.json();
//        alert('existing')
//        const updatedData =   {
//             ...data,
//             AUTH_URL: isB2c ? data.AUTH_URL_B2C : data.AUTH_URL,
//             CLIENT_ID: isB2c ? data.CLIENT_ID_B2C : data.CLIENT_ID,
//             CLIENT_SECRET: isB2c ? data.CLIENT_SECRET_B2C : data.CLIENT_SECRET,
//             TWO_FACT_SCOPE: isB2c ? data.TWO_FACT_SCOPE_B2C : data.TWO_FACT_SCOPE,
//             // APP_URL: isB2c ? data.APP_URL_B2C : data.APP_URL,
//             GOOGLE_CLIENT_ID: isB2c ? data.GOOGLE_CLIENT_ID_B2C : data.GOOGLE_CLIENT_ID,
//             APPLE_TEAM_ID: isB2c ? data.APPLE_TEAM_ID_B2C : data.APPLE_TEAM_ID,
//             APPLE_REDIRECT_URI: isB2c ? data.APPLE_REDIRECT_URI_B2C : data.APPLE_REDIRECT_URI,
//           };
//         console.log(updatedData,"updatedData appConfigData")
//         const appConfigPayload = { appConfigData: updatedData };
//         store.dispatch({ type: 'STORE_APPCONFIGDATA', payload: appConfigPayload });
//         return updatedData;
//     }
// }



export async function storeData(key, value) {
    var isStored = false;
    try {
    localStorage.setItem(key, JSON.stringify(value));
        isStored = true;
        return isStored;
    } catch (error) {
        return isStored;
    }
}
export const isEmailValid = (email) => {
    if (!email || email.trim() === '') {
        return "empty";
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        return "not valid"
    }
    return "valid";
};

// export function showKudzuPlusPrompt(responseObj){
//     if (responseObj != undefined ) {
//         if (responseObj.length > 0) {
//             return responseObj[0].ShowUpgradePrompts
//         }
//     }else{
//         return false;
//     }
// }
export function showKudzuPlusPrompt(responseObj){
    if (responseObj != undefined ) {
        if (responseObj) {
            const isShowPrompt = responseObj?.Subscription == undefined && responseObj?.Promos?.length > 0 
            return isShowPrompt
            // return responseObj[0].ShowUpgradePrompts
        }
    }else{
        return false;
    }
}
export function subScriptionCanceledFun(responseObj){
    if (responseObj != undefined ) {
        if (responseObj) {
            const subScriptioCanceled = responseObj?.SubscriptionCancelled
            return subScriptioCanceled
        }
    }else{
        return false;
    }
}

export function showPrompt(responseObj){
    if (responseObj != undefined ) {
        if (responseObj) {
            const isShowPrompt = responseObj?.Subscription == undefined && responseObj?.Promos?.length > 0
            return isShowPrompt
            // return responseObj[0].ShowUpgradePrompts
        }
    }else{
        return false;
    }
}
export function isSmiOneAccountTrue(responseObj){
    if (responseObj != undefined ) {
        if (responseObj) {
          const isShowPrompt = responseObj.Cards.find(c => c?.ProgramKey === 112);
            return isShowPrompt
            // return responseObj[0].ShowUpgradePrompts
        }
    }else{
        return false;
    }
}

export function hasKudzuCardTrue(responseObj){
    if (responseObj != undefined ) {
        if (responseObj) {
          const isShowPrompt = responseObj.Cards.find(c => c?.AccountTypeBit63 === 64);
            return isShowPrompt
            // return responseObj[0].ShowUpgradePrompts
        }
    }else{
        return false;
    }
}

// export function getUserMembership(responseObj) {
//     {/*
//         If there is no subscription object, it is treated as Kudzu Basic
//         If there is no subscription object and has promo, it is treated as Kudzu Basic and also need to show upgrade flow.
//         If there is subscription, it is treated as Kudzu+.
//         If TrailRemainingDays > 0, it is in Trail
//         If TrailRemainingDays > 0 and ExtendTrailDays > 0, it is in Trail and had an option to extend the trail
//         If TrailRemainingDays = 0 and ExtendTrailDays = 0, it is in Kudzu+ paid subscription
//         */}
//     if (responseObj != undefined) {
//         if (responseObj?.Subscription) {
//             const { TrailRemainingDays, cancelled } = responseObj?.Subscription
//             if (TrailRemainingDays > 0) {
//                 const object = {
//                     membershipType: t('trial'),
//                     daysRemaining: TrailRemainingDays,
//                     extendTrial: TrailRemainingDays < 30 ? true : false,
//                     cancelled: cancelled
//                 }
//                 return object
//             } else if (TrailRemainingDays === 0) {
//                 const object = {
//                     membershipType: t('plus'),
//                     daysRemaining: "",
//                     extendTrial: false,
//                     cancelled: cancelled
//                 }
//                 return object
//             }
//         }
//     } else {
//         const object = {
//             membershipType: t('kudzu'),
//             daysRemaining: "",
//             extendTrial: false,
//             cancelled: false
//         }
//         return object
//     }
// }

export function getUserMembership(responseObj){
    {/*
        If there is no subscription object, it is treated as Kudzu Basic
        If there is no subscription object and has promo, it is treated as Kudzu Basic and also need to show upgrade flow.
        If there is subscription, it is treated as Kudzu+.
        If TrailRemainingDays > 0, it is in Trail
        If TrailRemainingDays > 0 and ExtendTrailDays > 0, it is in Trail and had an option to extend the trail
        If TrailRemainingDays = 0 and ExtendTrailDays = 0, it is in Kudzu+ paid subscription
        If the user has Kudzuplus subscription and cancelled is true, then show extend
        If the user has no subscription and SubscriptionCancelled is true, then show expired extend flow.
        */}
    if (responseObj != undefined ) {
        if(responseObj?.Subscription){
            const { TrailRemainingDays, RemainingDays, Cancelled, ProductName } = responseObj?.Subscription
            const object = {
                membershipType: TrailRemainingDays > 0 || TrailRemainingDays === -1 ? t('trial') : t('plus'),
                daysRemaining: RemainingDays > 0 ? RemainingDays : '',
                extendTrial: Cancelled,
                cancelled: Cancelled,                
            }
            return object
            
            // if(TrailRemainingDays > 0){
            //     const object ={
            //         membershipType: translate('trial'),
            //         daysRemaining: TrailRemainingDays,
            //         extendTrial: TrailRemainingDays < 30 ? true : false,
            //         cancelled: Cancelled
            //     }
            //     return object
            // } else if(TrailRemainingDays === 0){
            //     const object ={
            //         membershipType: translate('plus'),
            //         daysRemaining: "",
            //         extendTrial: false,
            //         cancelled: Cancelled
            //     }
            //     return object
            // }
        }
    }else{
        const object ={
            membershipType: t('kudzu'),
            daysRemaining: "",
            extendTrial: false,
            cancelled: true
        }
        return object
    }
}

export async function storeDataInRedux(key, value) {
    this.props.dispatch({ type: key, payload: value });
}
export async function retrieveData(key) {
    const value = localStorage.getItem(key);
    if (value !== null) {
        return JSON.parse(value);
    }
    else
        return null;
}
 
//check email extension 

export function checkEmailExtension(email){
    debugger;
    const allowedExtensions = ['.edu'];
    const domain = email.substring(email.lastIndexOf('.'));
    return allowedExtensions.includes(domain); 
}



export const autoFocusFunction = (fieldArray, getValues, setFocus) => {
    const emptyField = fieldArray.find((item) => !getValues(item))
    setFocus(emptyField);
}

// (?=.*?[#@$?])

export const generateRegexExpression = (policy) => {

    let pattern = "";
    if (policy?.UppercaseLength > 0) pattern += `(?=(?:.*?[A-Z]){${policy?.UppercaseLength},})`;
    if (policy?.LowercaseLength > 0) pattern += `(?=(?:.*?[a-z]){${policy?.LowercaseLength},})`;
    if (policy?.NonAlphaLength > 0) pattern += `(?=(?:.*?[^a-zA-Z0-9]){${policy?.NonAlphaLength},})`;
    // if (policy?.NonAlphaLength > 0) pattern += `(?=(?:.*?[!@#$%^&*()_+-={}\\[\\]\\|;:'\",.<>/?\`~]){${policy?.NonAlphaLength},})`;
    if (policy?.NumericLength > 0) pattern += `(?=(?:.*?\\d){${policy?.NumericLength},})`;
    if (policy?.AlphaLength > 0) pattern += `(?=(?:.*?[A-Za-z]){${policy?.AlphaLength},})`;
    pattern = `^${pattern}.{${policy?.MinimumLength},${policy?.MaximumLength === 0 ? 1000 : policy?.MaximumLength}}$`;
    return new RegExp(pattern);
}
export const generateRegexExpression1 = (criteria, policy) => {

    let pattern = "";
    switch (criteria) {
        case "Uppercase":
            pattern += `(?=(?:.*?[A-Z]){${policy.UppercaseLength},})`;
            break;
        case "Lowercase":
            pattern += `(?=(?:.*?[a-z]){${policy.LowercaseLength},})`;
            break;
        case "NonAlpha":
            pattern += `(?=(?:.*?[!@#$%^&*()_+-={}\\[\\]\\|;:'\",.<>/?\`~]){${policy.NonAlphaLength},})`;
            break;
        case "Numeric":
            pattern += `(?=(?:.*?\\d){${policy.NumericLength},})`;
            break;
        case "Alpha":
            pattern += `(?=(?:.*?[A-Za-z]){${policy.AlphaLength},})`;
            break;
        case "MinMax":
            pattern += `.{${policy?.MinimumLength - 1},${policy?.MaximumLength === 0 ? 1000 : policy?.MaximumLength}}`
            break;
        case "Special":  // Add this case for special characters
            pattern += `(?=(?:.*?[^a-zA-Z0-9]){${policy.NonAlphaLength},})`;
            break;

        default:
            break;
    }

    pattern = `^${pattern}.+$`;
    return new RegExp(pattern);
}


export const formatDateOfBirthForUi = (dateOfBirth) => {
    return new Date(dateOfBirth).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };
  
  export const formatDateToDDMMYYYYFORSCH = (dateOfBirth) => {
  const date = new Date(dateOfBirth);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
 
  return `${day}/${month}/${year}`;
};

export const APP_ENV = 'APP_ENV';
export const BIOMETRIC = "biometric";
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const USERNAME = "USERNAME";
export const REFRESH_TOKEN = "REFRESH_TOKEN"
export const IS_TRUSTED_DEVICE = "IsTrustedDevice";
export const USER_PROFILE = "userProfile";
export const USER_CARDS = "userCards";
export const USER_ACTIVITIES = "userActivities";
export const USER_LANGUAGE = "userLanguage";
export const SPENDING = "Spending"
export const SAVING = "Saving"
export const SAVINGS = "Savings"

export const FaceID = "Face ID"
export const TouchID = "Touch ID"
export const Biometric = "Biometric"
export const FingerPrint = "Fingerprint Recognition"
export const APP_BG_TIME = "APP_BG_TIME";
export const APP_BG_TIME_IN_SECS = 1800;
export const CHECKING = "Checking";
export const AMOUNT_MAX_FILTERS = 500;
export const AMOUNT_MIN_FILTERS = 0;
export const TIME_MAX_FILTERS = 6;
export const TIME_MIN_FILTERS = 0;
export const SLIDER_MIN_POSITION = -10;
export const SLIDER_MAX_POSITION = 230;
export const SPENT_AMOUNT_DEFAULT_DAYS = 7;
export const MIN_PASSWORD_LENGTH = 1
export const PENDING = "Pending"
export const DEVICE_VERIFICATION = "DeviceVerification";
export const LOGIN = "Login";
export const MAX_RETRY_COUNT = 3;
export const TNC = "TnC";
export const PRIVACY_POLICY = "PrivacyPolicy";
export const ESIGN = "ESign";
export const ACH = "ACH"
export const SAVING_CARD_CODE = 32;
export const CHECKING_CARD_CODE = 64
export const SMIONE_CARD_CODE = 1;
export const SECURED_CARD_CODE = 256;
export const HOLIDAYS_STORAGE_KEY = 'HolidaysData';